import { createSlice } from "@reduxjs/toolkit";
import {
  adminGetRoles,
  getAdminAssignedUsers,
  getAdminAuditLog,
  getAdminPermissionsByName,
  getAllAdminUsers,
  getUnAssignedRoles,
} from "./roleAndPermissionActions";
import { IAdminRoles } from "./roleAndPermissionType";

const initialState: IAdminRoles = {
  adminRoleData: {
    totalRoles: 0,
    totalPermissions: 0,
    totalUsers: 0,
    auditLogsCount: 0,
    lastModifiedAuditLogDate: "",
    rolePermissionsResponses: [],
  },
  permissionData: [],
  auditLogData: {
    rolesAndPermissionsAuditLogs: [],
  },
  assignedUsersData: [],
  allAdminUsersData: [],
  unAssignedRoles: [],
};

const adminRolesSlice = createSlice({
  name: "adminRoles",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(adminGetRoles.fulfilled, (state, { payload }) => {
      state.adminRoleData = payload.data;
    });
    builder.addCase(
      getAdminPermissionsByName.fulfilled,
      (state, { payload }) => {
        state.permissionData = payload.data;
      }
    );
    builder.addCase(getAdminAuditLog.fulfilled, (state, { payload }) => {
      state.auditLogData = payload.data;
    });
    builder.addCase(getAdminAssignedUsers.fulfilled, (state, { payload }) => {
      state.assignedUsersData = payload.data;
    });
    builder.addCase(getAllAdminUsers.fulfilled, (state, { payload }) => {
      state.allAdminUsersData = payload.data;
    });
    builder.addCase(getUnAssignedRoles.fulfilled, (state, { payload }) => {
      state.unAssignedRoles = payload.data;
    });
  },
});

export default adminRolesSlice.reducer;
